import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { storeToken } from '../src/Reducers/index';
import { SnackbarProvider } from 'notistack';
import { DeleteAlertModal } from './Utils/others';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
//delete modal
DeleteAlertModal();
root.render(
  <Provider store={storeToken}>
    <SnackbarProvider>
      <App />
    </SnackbarProvider>
  </Provider >
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
